







import {Component} from 'vue-property-decorator'
import axios from 'axios'
import {apiV1AdminEventPagesPath} from '@/rails/routes'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import EventPageForm from "@/components/admin/event_pages/Form.vue"
import EventPage from "@/models/EventPage"

@Component({
  components: {
    EventPageForm
  }
})
export default class EventPageNew extends PageBase {
  eventPage = new EventPage()

  mounted(): void {
    super.mounted()
  }

  async save(): Promise<void> {
    try {
      const res = await axios.post(apiV1AdminEventPagesPath(), {
        event_page: this.eventPage.toParams()
      })
      this.eventPage = new EventPage(res.data)
      this.$router.push(`/admin/event_pages/${this.eventPage.id}/edit`)
      this.showMessage('変更を保存しました。')
    } catch (e) {
      console.log(e)
    }
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベントページ一覧',
        to: '/admin/event_pages',
        exact: true
      },
      {
        text: 'イベントページ新規作成'
      }
    ]
  }
}
